import { Container, Paper } from "@hagerty/react-components";
import { useScrollToTop } from "../../hooks/useScrollToTop";
import { ReactNode } from "react";
import clsx from "clsx";

type SettingsContainerProps = {
  children: ReactNode;
  paperClassName?: string;
  testid?: string;
};

/**
 * Top level container for all account settings pages.
 * This will get the page the correct styling (see globals.scss)
 */
export const SettingsContainer = ({
  children,
  paperClassName,
  testid,
}: SettingsContainerProps) => {
  useScrollToTop();

  return (
    <Container
      id="account-settings"
      className="my-4 my-md-6"
      isCentered
      testid={testid}
    >
      <Paper theme="light" className={clsx("w-100 m-auto", paperClassName)}>
        {children}
      </Paper>
    </Container>
  );
};
